<template>
  <site-banner pagina="sobre" />

  <div class="container">
    <div class="row">
      <div class="col-md-6">
        <div v-if="locale == 'pt'">
          <p>
            É através do sorriso que nos conectamos com as pessoas. Entregamos
            aos pacientes muito mais que um atendimento humanizado, mas
            tratamentos odontológicos de excelência e acessíveis. Acreditamos
            que um sorriso saudável pode trazer segurança, felicidade,
            bem-estar, reconhecimento e autoestima.
          </p>
          <p>
            Estamos há 19 anos conquistando sorrisos, com mais de 110 clínicas
            odontológicas no Brasil e 3 clínicas no Uruguai. Para ampliar a
            atuação e compartilhar o conhecimento adquirido ao longo da nossa
            trajetória, criamos o Instituto Sorrifácil. Com tudo que há de mais
            moderno e inovador para a prática do ensino e atendimentos
            odontológicos, o Instituto Sorrifácil se destaca como referência na
            prática da odontologia no Brasil.
          </p>
          <p>
            O principal objetivo é promover a boa prática no atendimento
            odontológico por meio da capacitação de profissionais, inovação e
            avanços tecnológicos. O Instituto Sorrifácil possui 4 pilares que
            são: Educação, Clínica, Inovação Tecnológica e Projeto Social.
          </p>
          <p>
            Nossas clínicas estão equipadas com o que há de mais moderno na
            odontologia, com tecnologias de última geração, além de transmitirem
            o conforto e qualidade que você precisa para realizar qualquer
            procedimento.
          </p>
          <p>
            Venha nos visitar e entender como podemos ajudar a transformar o seu
            sorriso.
          </p>
        </div>

        <div v-if="locale == 'es'">
          <p>
            Es a través de la sonrisa que conectamos con las personas.
            entregamos a los pacientes mucho más que un servicio humanizado,
            sino Excelentes y accesibles tratamientos dentales. creemos que una
            sonrisa saludable puede traer seguridad, felicidad, bienestar,
            reconocimiento y autoestima.
          </p>
          <p>
            Llevamos 19 años conquistando sonrisas, con más de 110 clínicas
            dentales en Brasil y 5 clínicas en Uruguay. Para ampliar el alcance
            y compartir los conocimientos adquiridos a lo largo de nuestra
            trayectoria, creamos el Instituto Sorrifácil. Con todo lo más
            moderno y innovador para la práctica de la enseñanza y el cuidado
            dental, el El Instituto Sorrifácil se destaca como un referente en
            la práctica de odontología en Brasil.
          </p>
          <p>
            El objetivo principal es promover las buenas prácticas en la
            atención al cliente odontología a través de la formación
            profesional, la innovación y avances tecnológicos. El Instituto
            Sorrifácil tiene 4 pilares que son: Educación, Clínica, Innovación
            Tecnológica y Proyecto Social.
          </p>
          <p>
            Nuestras clínicas están equipadas con los equipos más modernos del
            odontología, con tecnologías de punta, además de transmitir la
            comodidad y calidad que necesitas para realizar cualquier
            procedimiento.
          </p>
          <p>
            Venga a visitarnos y comprenda cómo podemos ayudar a transformar su
            sonrisa.
          </p>
        </div>

        <div class="my-5">
          <NuxtLink
            class="botao botao-laranja"
            :to="localePath('tratamentos', locale)"
          >
            {{ $t("Conheça nossos tratamentos") }}
          </NuxtLink>
        </div>
      </div>
      <div class="col-md-6 video-container">
        <iframe
          :title="tituloVideo"
          class="video"
          width="500"
          height="315"
          src="https://www.youtube.com/embed/MA7Q8uKXBSo"
          frameborder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope;"
          allowfullscreen
        />
      </div>
    </div>
  </div>

  <custom-lista
    class="sobre-detalhes-lista"
    :itens="locale == 'es' ? destaques_es : destaques_pt"
    :fixa="true"
  />

  <div class="sobre-valores-lista">
    <custom-lista
      class="sobre-valores-lista"
      :itens="locale == 'es' ? valores_es : valores_pt"
      width="300"
      height="auto"
    />
  </div>

  <site-noticias />
</template>

<script setup>
const { t, locale } = useI18n();
const localePath = useLocalePath();

const tituloVideo = t("Sobre os nossos tratamentos");

// Português
const destaques_pt = [
  {
    imagem: "destaque-mapa",
    local: true,
    titulo: "+ de 100 ",
    subtitulo: "clínicas odontológicas em todo Brasil e 3 no Uruguai.",
    class: "sobre-detalhes-cartao",
  },
  {
    imagem: "destaque-atendimento",
    local: true,
    titulo: "+ de 60mil",
    subtitulo: "atendimento odontológicos ao mês.",
    class: "sobre-detalhes-cartao",
  },
];

const valores_pt = [
  {
    titulo: "Visão ",
    texto:
      "Ser a marca mais reconhecida em nosso segmento nos mercados em que atuamos.",
    class: "sobre-valores-cartao",
  },
  {
    titulo: "Propósito",
    texto: "Conquistar sorrisos.",
    class: "sobre-valores-cartao",
  },
  {
    titulo: "Valores",
    texto:
      "- Ética que gera confiança. #- Transparência e simplicidade nas relações. #- Comprometimento com o resultado e meritocracia. #- Humanização e acessibilidade. #- Educação e inovação constantes.",
    class: "sobre-valores-cartao",
  },
];

// Espanhol
const destaques_es = [
  {
    imagem: "destaque-mapa",
    local: true,
    titulo: "+ de 100 ",
    subtitulo: "clínicas dentales en todo Brasil y 5 en Uruguay.",
    class: "sobre-detalhes-cartao",
  },
  {
    imagem: "destaque-atendimento",
    local: true,
    titulo: "+ de 60mil",
    subtitulo: "atención odontológica mensual.",
    class: "sobre-detalhes-cartao",
  },
];

const valores_es = [
  {
    titulo: "Visión",
    texto:
      "Ser la marca más reconocida de nuestro segmento en los mercados donde operamos.",
    class: "sobre-valores-cartao",
  },
  {
    titulo: "Objetivo",
    texto: "Conquista sonrisas.",
    class: "sobre-valores-cartao",
  },
  {
    titulo: "Valores",
    texto:
      "- Ética que genera confianza. #- Transparencia y sencillez en las relaciones. #- Compromiso con los resultados y meritocracia. #- Humanización y accesibilidad. #- Educación e innovación constante.",
    class: "sobre-valores-cartao",
  },
];

useSeoMeta({
  title: t("Sobre a ") + t("sorrifacil"),
  ogTitle: t("Sobre a ") + t("sorrifacil"),
  description: t("sorrifacil") + t(" especializada em implantes e ortodontia"),
  ogDescription:
    t("sorrifacil") + t(" especializada em implantes e ortodontia"),
});
</script>

<script>
export default {
  name: "SobrePagina",
};
defineI18nRoute({
  paths: {
    pt: "/sobre",
    es: "/sorrifacil",
  },
});
</script>
